// extracted by mini-css-extract-plugin
export default {"image":"picture_image__WwtZN","fallback":"picture_fallback__pUlcT picture_image__WwtZN"};